export default __webpack_public_path__ + "static/gaytsby-e0fc01a9a0a5c4198be67d2cf16e935c.png";